import React from 'react';

export type ErrorLabelProps = {
    error: string;
};

function ErrorLabel(props: ErrorLabelProps): React.JSX.Element {
    return <span className="block text-red text-body-12 mt-2 ml-2 whitespace-pre-wrap">{props.error}</span>;
}

export default ErrorLabel;
